import { FileUpload } from "@admin-ui/components/application/file-upload/file-upload-base";
import { Button } from "@admin-ui/components/primitives/base/buttons/button";
import { adminDestinationsStockPhotoSearchesPath } from "@travily/routes";
import { Trash01 } from "@untitledui/icons";
import { useState } from "react";
import { StockPhotoSearchModal } from "@/components/admin/StockPhotoSearchModal";
import { useImageUploadField } from "@/hooks/use-image-upload-field";

interface NewPhotoSectionProps {
  onPhotoChange: (signedId: string, stockPhotoUrl: string) => void;
}

export function NewPhotoSection({ onPhotoChange }: NewPhotoSectionProps) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const {
    previewUrl,
    isUploading,
    progress,
    onFileSelect,
    onRemove: handleRemove,
    setPreview,
  } = useImageUploadField({
    onUploaded: (signedId) => onPhotoChange(signedId, ""),
    onRemoved: () => onPhotoChange("", ""),
  });

  const handleFileDrop = (files: FileList) => {
    const file = files[0];
    if (file) onFileSelect(file);
  };

  const handleStockPhotoSelect = (urlOriginal: string, urlPreview: string) => {
    setPreview(urlPreview);
    onPhotoChange("", urlOriginal);
  };

  return (
    <div className="flex flex-col gap-3">
      {previewUrl && !isUploading ? (
        <>
          <div className="overflow-hidden rounded-xl">
            <img src={previewUrl} alt="Destination cover" className="aspect-video w-full object-cover" />
          </div>
          <div className="flex items-center gap-3">
            <Button size="sm" color="secondary" onClick={() => setIsSearchOpen(true)}>
              Replace
            </Button>
            <Button size="sm" color="link-gray" iconLeading={Trash01} onClick={handleRemove}>
              Remove
            </Button>
          </div>
        </>
      ) : (
        <>
          <FileUpload.Root>
            <FileUpload.DropZone
              accept="image/jpeg,image/png,image/webp"
              allowsMultiple={false}
              maxSize={10 * 1024 * 1024}
              hint="JPG, PNG or WebP (max. 10MB)"
              isDisabled={isUploading}
              onDropFiles={handleFileDrop}
            />
            {isUploading && (
              <FileUpload.List>
                <FileUpload.ListItemProgressBar name="Uploading photo..." size={0} progress={progress} type="img" />
              </FileUpload.List>
            )}
          </FileUpload.Root>
          <p className="text-sm text-tertiary">
            Or{" "}
            <button
              type="button"
              onClick={() => setIsSearchOpen(true)}
              className="font-medium text-brand-600 hover:text-brand-700"
              disabled={isUploading}
            >
              search stock photos
            </button>
          </p>
        </>
      )}

      <StockPhotoSearchModal
        isOpen={isSearchOpen}
        onOpenChange={setIsSearchOpen}
        onSelect={handleStockPhotoSelect}
        searchPath={adminDestinationsStockPhotoSearchesPath()}
      />
    </div>
  );
}
